module.exports = __webpack_public_path__ + "img/90_pourcent.b612a8e4.png";